
import FreespinsWheelResult from "integration/results/freespins-wheel-result";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import { Eval, FreespinUpdate, State, User } from "slotworks/integration/revolver/schema/spin-record-schema";
import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class FreespinsWheelResultBuilder implements ResultBuilder {

    public bonusId: string;
    public triggerAliases: string[];

    public filter(data: any): boolean {
        let spinResponse: SpinResponseSchema;

        if (data) {
            spinResponse = data as SpinResponseSchema;
        }

        return spinResponse && 
                spinResponse.RESULTS !== undefined && 
                revolverModel.isSpin(spinResponse.RESULTS.game) &&
                spinResponse.RESULTS.next_game === "FREESPIN_WHEEL_BONUS";;
    }

    public build(record: Record, data: any): Result[] {
        let spinResponse: SpinResponseSchema;

        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
        }

        const bonusResult = new FreespinsWheelResult();
        return [bonusResult];
    }
}

export default new FreespinsWheelResultBuilder();

export interface SpinResponseSchema {
    RESULTS: Results;
    USER: User;
    time: number;
}

export interface Results {
    additionalData: any;
    eval: Eval;
    game: string;
    next_game: string;
}